import { render, staticRenderFns } from "./chat-ia-pop-up.vue?vue&type=template&id=c817091e&"
import script from "./chat-ia-pop-up.vue?vue&type=script&lang=js&"
export * from "./chat-ia-pop-up.vue?vue&type=script&lang=js&"
import style0 from "./chat-ia-pop-up.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VSlideYTransition})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c817091e')) {
      api.createRecord('c817091e', component.options)
    } else {
      api.reload('c817091e', component.options)
    }
    module.hot.accept("./chat-ia-pop-up.vue?vue&type=template&id=c817091e&", function () {
      api.rerender('c817091e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/global/components/chat-ia-pop-up/chat-ia-pop-up.vue"
export default component.exports